import React, { Fragment, useEffect, useMemo, useState } from "react";
import DataTable from "./DataTable";
import AssignedEmployeeVisibleColumn from "./AssignedEmployeeVisibleColumn";
import ErrorBoundary from "../../ErrorBoundry";
import { useNavigate, useParams } from "react-router-dom";
import { Container, Row } from "reactstrap";
import Header from "./Header";

const EmployeeList = ({
  isLoading,
  deleteResult,
  deleteLTD,
  employeeID,
  ...props
}) => {
  const history = useNavigate();
  const params = useParams();
  const [deleteData, setDeleteData] = useState(null);
  const [additionalWhere, setAdditionalWhere] = useState("");

  useEffect(() => {
    setAdditionalWhere(` SupervisorIds like '%${params?.superVisorId}%' `);
  }, [params?.superVisorId]);

  useEffect(() => {
    if (
      deleteResult != undefined &&
      !!Object.keys(deleteResult).length &&
      !isLoading
    ) {
      setDeleteData({ dt: new Date() });
    }
  }, [deleteResult, isLoading]);

  return (
    <ErrorBoundary>
      <Fragment>
        <Container fluid={true}>
          <Row>
            <Header title={"Supervisor Assignment"} url={"payroll-employees"} />
          </Row>
        </Container>
      </Fragment>
      {!!params?.superVisorId && <DataTable
        tableName={"vw_EmployeeListingBySupervisorId_V2"}
        visibleColumns={AssignedEmployeeVisibleColumn}
        title={`Assigned Employees - ${params?.superVisorId}`}
        sort={[{ field: "EndDate", dir: "desc" }]}
        deleteData={deleteData}
        isLoading={isLoading}
        additionalWheres={additionalWhere}
        checkboxAction={true}
        checkboxKey={"EmployeeNo"}
        isAssignEmployee={true}
        setDeleteData={setDeleteData}
        supervisorId={params?.superVisorId}
      />}
    </ErrorBoundary>
  );
};

export default EmployeeList;
